<template>
  <div>
    <div v-if="!loading">
      <div v-if="dataSet">
        <div class="mb-4" v-for="(item, i) in dataSet" :key="`sect_${i}`">
          <v-card
            class="rounded_max d-flex"
            elevation="1"
            style="overflow: hidden"
            @click.prevent="
              toDetail(
                item,
                permissions.includes('MENTOR') ||
                  permissions.includes('UPCM') ||
                  permissions.includes('FASILITATOR')
                  ? true
                  : false
              )
            "
          >
            <div
              class="strip"
              :style="`background: ${color ? color : '#f0ac91'}`"
            ></div>
            <v-row no-gutters>
              <v-col cols="10" md="11" lg="11">
                <div class="pa-3 d-flex align-center">
                  <v-btn
                    fab
                    :color="color ? color : '#f0ac91'"
                    dark
                    class="mr-2"
                    depressed
                    small
                  >
                    <v-icon> {{ item.icon }}</v-icon>
                  </v-btn>
                  <div>
                    <b> {{ item.title }} </b>
                    <p class="default_txt ma-0">
                      {{ item.data_module.description }}
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col v-if="type == 'scholar'" cols="2" md="1" lg="1"
                ><div
                  class="pa-3 d-flex align-center justify-end handle"
                  style="height: 100%"
                >
                  <v-icon
                    :color="color ? color : '#f0ac91'"
                    v-if="
                      dataDoneModule.some(
                        (dataScholar) => dataScholar.module_id == item.module_id
                      ) &&
                      dataDoneModule.some(
                        (dataScholar) =>
                          dataScholar.instance_id == item.instance_id
                      )
                    "
                    >mdi-checkbox-marked-circle-outline</v-icon
                  >
                  <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
                </div></v-col
              >
            </v-row>
          </v-card>
        </div>
        <div
          v-if="!dataSet.length"
          class="d-flex align-center justify-center flex-column"
        >
          <img
            src="../../../../assets/img/gundam/LMS Aset Illustrasi No Modules.png"
            height="200px"
            alt=""
          />
          <b class="default_txt my-3"
            >The module is not yet available in this section</b
          >
          <p class="default_txt ma-0">
            Module bisa berupa materi, quiz, assginment dan lain2
          </p>
        </div>
      </div>
    </div>
    <div v-if="loading" class="_temp_list">
      <v-row no-gutters>
        <v-col cols="12" v-for="i in 3" :key="i">
          <div class="py-3">
            <v-skeleton-loader
              type="image"
              class="rounded_max"
              height="80px"
            ></v-skeleton-loader>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "listModule",
  props: ["color", "type"],
  mounted() {
    this.fetchData();
    if (this.type == "scholar") {
      this.fetchDataDone();
    }
  },
  // =>
  data() {
    return {
      loading: true,
      dataSet: null,
      dataDoneModule: [],
      msg: "",
      icon: [
        {
          id: 1,
          mdi: "mdi-order-bool-ascending-variant",
        },
        {
          id: 2,
          mdi: "mdi-clipboard-check",
        },

        {
          id: 3,
          mdi: "mdi-book-check",
        },
        {
          id: 4,
          mdi: "mdi-text-box-check",
        },
        {
          id: 5,
          mdi: "mdi-notebook-check",
        },

        {
          id: 6,
          mdi: "mdi-book-sync-outline",
        },
        {
          id: 7,
          mdi: "mdi-puzzle-check",
        },
        {
          id: 8,
          mdi: "mdi-account-check-outline",
        },
      ],
    };
  },
  //   =>
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/course/section/module/${this.$route.params.idSection}?include=dataModule`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.dataSet = data.data;
          this.dataSet.forEach((el) => {
            this.icon.forEach((ico) => {
              if (el.module_id == ico.id) {
                el["icon"] = ico.mdi;
              }
            });
          });
          if (this.type == "scholar") {
            this.fetchDataDone();
          }
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchDataDone() {
      this.loading = true;
      let data = {
        path: `scholar/course/section/checklist?course_section_id=${this.$route.params.idSection}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.dataDoneModule = data;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    toDetail(item, notScholar) {
      let section = item.course_section_id;
      let course = this.$route.params.idCourse;
      if (notScholar) {
        this.$router.push(
          `/module/inclass/${section}/${course}/${item.module_id}/${item.instance_id}/${item.data_module.title}/config`
        );
      } else if (item.data_module.title == "Assessment") {
        this.$router.push(
          `/assessment/${section}/${course}/${item.module_id}/${item.instance_id}/test`
        );
      } else {
        this.$router.push(
          `/module/inclass/${section}/${course}/${item.module_id}/${item.instance_id}/${item.data_module.title}/view`
        );
      }
    },
  },
};
</script>

<style scoped>
.strip {
  padding: 3px;
  width: 10px;
  max-height: 100%;
  border-radius: 0 !important;
}
</style>
